export const HOME_ROUTE_ROOT = '/home';

export const HOME_ROUTES = {
  HOME_PAGE: HOME_ROUTE_ROOT,
  OUTBOUND: `${HOME_ROUTE_ROOT}/outbound`,
  INBOUND: `${HOME_ROUTE_ROOT}/inbound`,
  STO: `${HOME_ROUTE_ROOT}/sto`,
};
